<template>
  <v-navigation-drawer v-if="!loading" app clipped right width="300">
    <v-tabs
      v-model="selectedTab"
      background-color="accent-4"
      center-active
      dark
    >
      <v-tab :key="env" v-for="(_, env) in releases">{{ env }}</v-tab>
      <v-tabs-items v-model="selectedTab">
        <v-tab-item nav :key="env" v-for="(release, env) in releases">
          <v-container class="rado">
            <div class="caption d-flex justify-space-between mb-2">
              <i>Last updated on {{ fromTimestamp(release.latestOn) }}</i>
            </div>
            <v-row
              dense
              v-for="current in release.current.filter(
                comp => zone == comp.zone
              )"
              :key="current.id"
            >
              <v-col class="font-weight-bold">
                {{ current.artifact }}
              </v-col>
              <v-col
                :class="
                  differentArtifacts[current.artifact]
                    ? 'highlight-diff body-2 grey--text ' +
                      (differentArtifacts[current.artifact].localeCompare(
                        current.sources[0].buildno
                      ) == -1
                        ? 'highlight-ahead'
                        : '')
                    : ' body-2'
                "
                :title="
                  differentArtifacts[current.artifact]
                    ? differentArtifacts[current.artifact]
                    : current.completedOn.formatted
                "
              >
                {{ current.sources[0].buildno }}
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-navigation-drawer>
</template>
<script>
import moment from 'moment';

export default {
  components: {},
  name: 'ReleasesSummary',
  props: {
    releases: {
      type: Object,
      required: true
    },
    tab: {
      type: Number,
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    },
    zone: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      selectedTab: this.tab
    };
  },
  watch: {
    tab: function(val) {
      this.selectedTab = val;
    }
  },
  computed: {
    differentArtifacts() {
      const diffs = {};

      if (this.selectedTab !== this.tab) {
        const compare = Object.keys(this.releases)[this.tab];
        const compareWith = Object.keys(this.releases)[this.selectedTab];
        for (let compareWithCurrent of this.releases[compareWith].current) {
          for (let current of this.releases[compare].current) {
            if (
              current.zone == compareWithCurrent.zone &&
              compareWithCurrent.artifact == current.artifact &&
              compareWithCurrent.sources[0].buildno !=
                current.sources[0].buildno
            ) {
              diffs[current.artifact] = current.sources[0].buildno;
            }
          }
        }
      }
      return diffs;
    }
  },
  methods: {
    fromTimestamp: function(timestamp) {
      return moment.unix(timestamp).format('LLLL');
    }
  }
};
</script>
<style>
.highlight-diff {
  text-shadow: 0px 0px 2px #ff0;
}

.highlight-diff.highlight-ahead {
  text-shadow: 0px 0px 2px #59dc64;
}
</style>
